import script from "./CategoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryView.vue?vue&type=script&setup=true&lang=js"

import "./CategoryView.vue?vue&type=style&index=0&id=5444dcfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5444dcfa"]])

export default __exports__